import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Donut } from "src/components/svg";
import { ProgramAvailablity } from "src/enums";
import { DateService } from "src/services";
import { ProgramDetail, ProgramViewAction } from "src/store";

export const ProgramViewCountDown: React.FC = () => {


    //#region dependencies

    const dispatch = useDispatch();
    const programInfo: ProgramDetail = useSelector((state: any) => state.ProgramViewState);

    //#end region

    //#region properties

    const remainingToStart = programInfo.info?.calculatedRemainingToStart || 0;
    const remaining = DateService.getRemainingTime(remainingToStart);

    const timer = useRef<NodeJS.Timeout | null>(null);

    //#end region

    //#region methods

    const clearTimer = () => {
        try {
            if (timer.current) clearTimeout(timer.current);
        }
        catch { }
    };

    //#end region

    //#region effects

    useEffect(() => {


        const startTimer = () => {
            if (remainingToStart <= 0) {
                if (programInfo.currentStream &&
                    ![ProgramAvailablity.NeedPackage, ProgramAvailablity.NeedPackageCountDown, undefined].includes(programInfo.availability)) {
                    dispatch(ProgramViewAction.requestProgramStreamData(programInfo.currentStream, programInfo.info?.qualityConfig));
                }
                else {
                    dispatch(ProgramViewAction.lockProgram());
                }
                clearTimer();
                return;
            }

            timer.current = setTimeout(() => {
                dispatch(ProgramViewAction.decreaseRemainingTime());
            }, 1000);
        };

        startTimer();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [remainingToStart]);


    useEffect(() => {

        return clearTimer;

    }, []);

    //#end region


    if (
        programInfo.availability !== ProgramAvailablity.CountDown &&
        programInfo.availability !== ProgramAvailablity.QualityNeedPackageCountdown &&
        programInfo.availability !== ProgramAvailablity.NeedPackageCountDown
    ) return null;

    const renderDonuts = (countdownOnly: boolean) => (
        <div className={`row component-contdown${countdownOnly ? " contdown-only" : ""}`}>
            {remaining.filter((x) => x.visible).map((x) => (
                <div className="component-contdown--countdown-graph" key={x.title}>
                    <Donut {...x} />
                    <span className="component-contdown--countdown-label text-rtl">
                        <span>{x.title}</span>
                    </span>
                </div>
            ))}
        </div>
    );

    return renderDonuts(true);

};